import React, { useEffect, useRef, useState } from "react";
import { MARKVIEWED_ONDEMAND, ON_DEMANDSIGNALR, SIGNAL_R_TOKEN } from "../Utils/constants";
import { useDispatch } from "react-redux";
import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { isQ2ServiceProvider } from "../Utils/ServiceProviders/q2";
import { isLogin } from "../Utils/token";
import { setNotificationCount } from "../Utils/ServiceProviders/banno";
import { sleep } from "../Utils";
import { useLocation } from "react-router";
import { apiCache } from "../Store/saga/apiSaga";


const SignalR = (props) => {

    const location = useLocation();
    const dispatch = useDispatch();
    const viewedIds = useRef(new Set());
    const [connection, setConnection] = useState(null);
    // Ref always reflects the current Redux signalr state so WebSocket handlers
    // can read it without stale-closure issues. Updated after every render.
    const signalrRef = useRef({ signalBankCalloutMsg: [], signalAchDelayedMsg: {} });

    useEffect(() => {
        signalrRef.current = props.state.signalr || { signalBankCalloutMsg: [], signalAchDelayedMsg: {} };
    });

    useEffect(() => {
        getSignalRDemand();
    }, [])

    useEffect(() => {
        const excludedPaths = [
        "/parent/children/card",
        "/parent/tenant/enrollment/step0"
        ];

        if (!excludedPaths.some(p => location.pathname.includes(p))) {
            setNotificationCount(
                props,
                props.state.signalr?.signalBankCalloutMsg.length
            );
        }
    }, [props.state && props.state.signalr])


    useEffect(() => {
        if (connection) {
            connection
                .start()
                .then(() => {

                    // ❗ Ensure handler is not registered multiple times
                    connection.off("ReceiveMessage");

                    connection.on("ReceiveMessage", (res, messageId) => {
                        try {
                            let msgObj = {
                                "msg": JSON.parse(res),
                                "msgId": messageId
                            }
                            console.log('signalr received : ', msgObj);

                            if (msgObj.msg && msgObj.msg.messageType && msgObj.msg.messageType === "Q2Router") {
                                tectonQ2Router(msgObj);
                            } else if (msgObj.msg && msgObj.msg.messageType && msgObj.msg.messageType === "Q2Tecton") {
                                tectonCamden(msgObj);
                            } else if (msgObj.msg && msgObj.msg.messageType && (msgObj.msg.messageType === "AccountDataUpdate" || msgObj.msg.messageType === "AccountDataDelete")) {
                                handleAccountDataSignal();
                            } else {
                                const isCallout = (
                                    (msgObj.msg && msgObj.msg.Message && msgObj.msg.MessageType) ||
                                    (msgObj.msg && msgObj.msg.message && msgObj.msg.messageType && (msgObj.msg.message || msgObj.msg.Message)) ||
                                    (msgObj.msg && msgObj.msg.title && (msgObj.msg.message || msgObj.msg.Message))
                                );
                                if (isCallout) {
                                    // Always build from the current Redux state so messages
                                    // dismissed elsewhere are never re-added.
                                    const currentMsgs = signalrRef.current.signalBankCalloutMsg;
                                    if (!currentMsgs.some(m => m.msgId === msgObj.msgId)) {
                                        dispatch({
                                            type: 'SIGNALR_SET_TRIGGER',
                                            payload: {
                                                signalAchDelayedMsg: signalrRef.current.signalAchDelayedMsg,
                                                signalBankCalloutMsg: [...currentMsgs, msgObj],
                                            },
                                        });
                                    }
                                }
                            }
                        } catch (e) { console.error(e) }
                    });

                    sleep(1000);
                    getSignalRDemand(false);

                })
                .catch((error) => {
                    connection.stop();
                    getSignalRDemand();
                });

            connection.onreconnected(() => {
                console.log("SignalR reconnected");

                getSignalRDemand(false)
            });

            return () => {
                connection.off("onreconnected");
            };
        }
    }, [connection]);// eslint-disable-line react-hooks/exhaustive-deps


    const handleAccountDataSignal = () => {
        console.log('[SignalR] AccountDataUpdate/Delete received — clearing accounts cache and triggering refresh');
        Object.keys(apiCache).filter(k => k.includes('v7/accounts')).forEach(k => delete apiCache[k]);
        dispatch({ type: 'SIGNALR_ACCOUNTS_REFRESH', payload: Date.now() });
    };

    const connectSignalR = () => {
        const hubName = `BankCompletion`;
        props._list(SIGNAL_R_TOKEN, null, res => {
            const connect = new HubConnectionBuilder()
                .withUrl(res.connectionString, { accessTokenFactory: () => res.accessToken })
                .configureLogging(LogLevel.None)
                .withAutomaticReconnect()
                .build();

            setConnection(connect);
        })
    }

    const getSignalRDemand = (isSignalR = true) => {
        if (isLogin()) {
            props._post(ON_DEMANDSIGNALR, null, (res) => {
                if (isSignalR) {
                    sleep(2000);
                    connectSignalR();
                }
            })
        }
    }

    const tectonQ2Router = (msgObj) => {
        //msgObj.msg.messageType
        markSingalMsgViewed(msgObj.msgId, -1)
        if (isQ2ServiceProvider(props) && msgObj.msg?.details?.route) {
            console.log(`tectonQ2Router calling dynamic ${msgObj.msg?.details?.route}`)
            window.tecton.sources.requestExtensionData({ ...msgObj.msg?.details }).then((xhr) => {
                // Do something with response
            }).catch((xhr) => {
                console.log(xhr);
                // Fires for non 200 series responses
            })

        } else if (isQ2ServiceProvider(props)) {
            window.tecton.actions.notifyRefetchAccounts()
        } else {
            console.log(`tectonQ2Router calling dynamic failed`)
        }

    }

    const tectonCamden = (msgObj) => {

        if (isQ2ServiceProvider(props)) {
            if (window.tecton && window.tecton.actions) {
                setTimeout(() => {
                    console.log("tecton calling requestExtensionData refetch_hq")
                    window.tecton.sources.requestExtensionData({
                        route: 'refetch_hq',
                        body: null
                    }).then((xhr) => {
                        // Do something with response
                        setTimeout(() => {
                            console.log("tecton calling notifyRefetchAccounts")
                            window.tecton.actions.notifyRefetchAccounts()
                            markSingalMsgViewed(msgObj.msgId, -1)
                        }, 5000)

                    }).catch((xhr) => {
                        console.error(xhr);
                        setTimeout(() => {
                            console.log("tecton calling notifyRefetchAccounts")
                            window.tecton.actions.notifyRefetchAccounts()
                            markSingalMsgViewed(msgObj.msgId, -1)
                        }, 5000)
                        // Fires for non 200 series responses
                    })
                }, 7000);


            } else {
                console.log(`tecton not able to notifyRefetchAccounts`)
            }
            // if (window.tecton && window.tecton.sources) {
            //   console.log("tecton calling requestExtensionData")
            //   window.tecton.sources.requestExtensionData({
            //     route: 'create_user',
            //     body: null
            //   }).then((xhr) => {
            //     // Do something with response
            //   }).catch((xhr) => {
            //     console.error(xhr);
            //     // Fires for non 200 series responses
            //   })
            // } else {
            //   console.error("tecton calling failed requestExtensionData")
            // }

        }
    }

    const markSingalMsgViewed = (notificationId, type) => {

        // prevent duplicate calls
        if (viewedIds.current.has(notificationId)) {
            return;
        }

        viewedIds.current.add(notificationId);

        props._post(MARKVIEWED_ONDEMAND(notificationId), null, res => {

            if (type === 0) {
                const filtered = signalrRef.current.signalBankCalloutMsg.filter(msg => msg.msgId !== notificationId);
                dispatch({
                    type: 'SIGNALR_SET_TRIGGER',
                    payload: {
                        signalAchDelayedMsg: signalrRef.current.signalAchDelayedMsg,
                        signalBankCalloutMsg: filtered,
                    },
                });
            }

            if (type === 1) {
                dispatch({
                    type: 'SIGNALR_SET_TRIGGER',
                    payload: {
                        signalAchDelayedMsg: {},
                        signalBankCalloutMsg: signalrRef.current.signalBankCalloutMsg,
                    },
                });
            }

        }, err => {

        }, false)
    }

    return (
        <></>
    );
};

export default SignalR;
